import React from "react";
import {inject, observer} from "mobx-react";
import Header from "../../header/header";
import LegalGroup from "../../legalGroup/legalGroup";
import LegalForm from "../../insurer/legalForm/legalForm";
import {ClientDataType, ClientModel, LegalFormClientData} from "../../../../helpers/client";
import {CalculateStore} from "../../../../stores/calculateStore";
import DeleteIcon from "@material-ui/icons/Delete";
import {ClientStore} from "../../../../stores/clientStore";
import ClientAddress from "../../clientAddress/clientAddress";
import "./insuredData.scss";
import {CalculationService} from "../../../../services/services/calculationService";
import InsurerPersonData from "../../../../helpers/insurerPersonData";
import InsurerCompanyData from "../../../../helpers/insurerCompanyData";

interface InsuredDataProps {
  calculateStore?: CalculateStore;
  clientStore?: ClientStore;
  calculationService?: CalculationService;
  client: ClientModel;
  insuredIndex?: number;
  disabled: boolean;
  disabledAddress?: boolean;
  displayAddressForm: boolean;
  className?: string;
}

@inject("clientStore", "calculateStore", "calculationService")
@observer
export default class InsuredData extends React.Component<InsuredDataProps> {

  public render() {
    const legalForm = this.props.client.legalForm!;
    const clientDataType = LegalFormClientData[legalForm.value!];
    const disabledAddress = this.props.disabled && this.props.disabledAddress !== false;

        return (
            <div className={`insured-data ${this.props.className}`}>
                {this.renderHeader()}
                <LegalGroup client={this.props.client} disabled={this.props.disabled}
                            label="Rodzaj ubezpieczonego"/>
                <LegalForm client={this.props.client} disabled={this.props.disabled}/>
                {(clientDataType === ClientDataType.PERSON ? this.renderPersonData() : "")}
                {(clientDataType === ClientDataType.COMPANY ? this.renderCompanyData() : "")}
                {(clientDataType === ClientDataType.PERSON_AND_COMPANY ? this.renderOtherData() : "")}
                {this.props.displayAddressForm && (
                    <ClientAddress client={this.props.client} disabled={disabledAddress}/>
                )}
            </div>
        );
    }

    private renderHeader() {
        const displayDeleteIcon = !this.props.client.insurer && !this.props.disabled && this.props.clientStore!.insureds.length !== 1;

        return (
            <div className="header-wrapper">
                <Header type="medium" mainHeader={!this.props.insuredIndex
                    ? "Ubezpieczony"
                    : "Ubezpieczony nr " + (this.props.insuredIndex! + 1)}/>
                {displayDeleteIcon && (
                    <DeleteIcon className="remove-insured" titleAccess="Usuń ubezpieczonego"
                                onClick={() => {
                                    this.props.clientStore!.removeInsured(this.props.client.id);
                                    this.props.calculationService!.setRisksNetworkForAllPackages();
                                }}/>
                )}
            </div>
        );
    }

    private renderPersonData() {
        return <InsurerPersonData client={this.props.client} disabled={this.props.disabled}
                                  refreshRisks={true}/>;
    }

    private renderCompanyData() {
        return <InsurerCompanyData client={this.props.client} disabled={this.props.disabled}/>;
    }

    private renderOtherData() {
        return <div className="other">
            {this.renderPersonData()}
            {this.renderCompanyData()}
        </div>;
    }
}
